"use strict";
/* eslint-disable no-var */
/*
 * This file sets the __webpack_public_path__ which tells webpack the CDN base url
 * from which to load assets and resources (like images, lazy loaded scripts).
 * Planner Client ECS is authoritative; Teams Tasks ECS remains a rollout fallback.
 * See: https://webpack.js.org/guides/public-path/#on-the-fly
 */
function getPlannerPublicPath() {
    const plannerGlobal = Reflect.get(globalThis, "planner");
    if (!plannerGlobal || typeof plannerGlobal !== "object" || !("sessionmetadata" in plannerGlobal)) {
        return undefined;
    }
    const sessionMetadata = plannerGlobal.sessionmetadata;
    if (!sessionMetadata || typeof sessionMetadata !== "object" || !("publicPath" in sessionMetadata)) {
        return undefined;
    }
    return typeof sessionMetadata.publicPath === "string" ? sessionMetadata.publicPath : undefined;
}
const plannerPublicPath = getPlannerPublicPath();
const ttPublicPath = typeof msTeamsTasks !== "undefined" ? msTeamsTasks?.config?.PublicPath : undefined;
__webpack_public_path__ = plannerPublicPath || ttPublicPath;
